<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content>
  @if (content) {
    <p
      class="content">
      {{content}}
    </p>
  }

  <mat-form-field>
    @if (isSingleLine) {
      <input matInput
        [placeholder]="placeholder"
        [formControl]="formControl"
        [maxlength]="maxLength"
        [minlength]="minLength">
    } @else {
      <textarea class="multi-line"
        matInput
        [placeholder]="placeholder"
        [formControl]="formControl"
        [maxlength]="maxLength"
        [minlength]="minLength">
      </textarea>
    }


    @if (formControl.hasError('required')) {
      <mat-error>
        Field is required
      </mat-error>
    }
    @if (hasMinLength) {
      <mat-hint
        align="start"
        class="minimum-characters">
        Requires at least {{minLength}} {{characterLabel}}
      </mat-hint>
    }
    @if (hasMaxLength) {
      <mat-hint
        align="end"
        class="maximum-characters">
        Characters: {{formControl.value.length}}/{{maxLength}}
      </mat-hint>
    }
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button
    mat-dialog-close
    class="button"
    color="accent">
    Cancel
  </button>

  <button mat-button
    color="accent"
    class="button"
    [disabled]="isDisabled"
    (click)="onTriggerAction()">
    {{actionButtonText}}
  </button>
</mat-dialog-actions>
